//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_components";

export default function ProcessExamList() {
  return (
    <div className="row">
      <Suspense>
        <Content />
      </Suspense>
    </div>
  );
}
